import { useSelector } from "react-redux";
import { Layout } from "../generalLayout";
import { Navigate } from "react-router-dom";

export default function ProtectedRoutes(props) {
  // allow access to protected routes
  // if validated, render Layout, which renders Header, Footer, request Page Component
  // if not validated, navigate to login page
  // props:
  //    admin (boolean): true if admin route is requested

  // -> read isAuthenticated/isAdmin from store
  // (backend passport handles authorization verification for every api request to protected route)
  const { isAuthenticated, isAdmin } = useSelector((state) => state.user);
  
  // admin route requested
  if (props.admin) {
    if (isAuthenticated && isAdmin) {
      return <Layout admin={true} />;
    }
    // protected user route requested
  } else if (isAuthenticated) {
    return <Layout admin={false} />;
  }
  return <Navigate to="/login" />;
}
